<template>
  <footer
    class="hina-footer"
    role="contentinfo"
  >
    <BaseContainer inner-class="hina-footer-inner" class="hina-footer-container">
      <div class="global-hina-footer-logo">
        <BaseLink to="/" class="global-hina-footer-logo-link">
          <LocaleLogoHina
            layout="left-stack"
            class="global-hina-footer-logo-svg"
          />
        </BaseLink>
      </div>
      <div
        class="hina-footer-nav"
      >
        <BaseLink to="/about">
          {{ lst(dapLangGlobal.footer.about, ls(dapLangGlobal.serviceName)) }}
        </BaseLink>
        <a :href="isJa ? 'https://www.ndl.go.jp' : 'https://www.ndl.go.jp/en'">
          {{
            ls(dapLangGlobal.footer.nationalDietLibraryHomePage)
          }}
        </a>
        <a :href="isJa ? 'https://ndlsearch.ndl.go.jp' : 'https://ndlsearch.ndl.go.jp/en'">
          {{
            ls(dapLangGlobal.footer.ndlSearch)
          }}
        </a>
        <BaseLink to="/news">
          {{ ls(dapLangGlobal.footer.news) }}
        </BaseLink>
        <BaseLink to="/contact">
          {{ ls(dapLangGlobal.footer.contact) }}
        </BaseLink>
      </div>
      <div class="hina-footer-copyright">
        {{ 
          'Copyright © 2013- National Diet Library. All Rights Reserved.'
        }}
      </div>
    </BaseContainer>
  </footer>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
const { ls, lst, isJa } = useI18n()
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.hina-footer {
  border-top: 1px solid #1F7F1F;
  background-color: rgb(230 247 225);
  padding-top: 2rem;
  padding-bottom: 2rem;
  color: $black;
}
.hina-footer-container {
  @include is-mobile {
    max-width: 420px;
    margin: 0 auto;
  }
}

.hina-footer-inner {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  @include is-tablet {
    gap: 1rem;
  }
  .global-hina-footer-logo {
    display: flex;
    justify-content: center;
    margin-bottom: 2rem;
    .global-hina-footer-logo-link {
      display: inline-block;
      .global-hina-footer-logo-svg {
        height: 100%;
        max-height: 5rem;
        width: 100%;
      }
    }
  }
  .footer-stripes {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: calc(0.25rem * 6);
    @include is-tablet {
      flex-direction: row;
      // .generated-14
      margin-bottom: 0.5rem;
    }
    .footer-strip-item {
      flex-grow: 1;
      border-radius: 0.5rem;
      border-width: 1px;
      border-color: green;
      border-style: solid;
      background-color: white;
      padding: calc(0.25rem * 3);
      text-align: left;
      &:hover { border-color: $jps-gray-600; }
      h2 {
        //font-size: 1rem;
        //line-height: 1.5;
        font-size: 1.125rem;
        line-height: 1.75rem;
        font-weight: 700;
        @include is-tablet {
          margin-top: calc(0.25rem * 1);
          margin-bottom: calc(0.25rem * 1);
        }
      }
      p {
        //font-size: 0.75rem;
        //line-height: calc(1.75 / 1.25);
        font-size: 0.75rem;
        line-height: 1rem;
      }
    }
  }
  .hina-footer-nav {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 0.5rem 4rem;
    color: $jps-gray-600;
    flex-direction: row;
    @include is-mobile {
      flex-direction: column;
      gap: 1rem;
      align-items: flex-start;
    }
  }
  .hina-footer-copyright {
    margin-top: 2rem;
    text-align: center;
    font-size: 0.875rem;
    line-height: 1.25rem;
    word-wrap: break-word;
    &::after {
      content: " 国立国会図書館";
    }
    @include is-mobile {
      white-space: pre-wrap;
      word-break: normal;
      &::after {
        content: "\A国立国会図書館";
      }
    }
  }
}
</style>
